import React, { useEffect, useState } from 'react';
//
import { useSelector, useDispatch } from 'react-redux';
//
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
//
import { setTypeMouseCursor } from 'app/actions/Core/css.effect.action';
//
import { Button } from 'antd';
// Translation
import withTranslations from 'app/components/HOGs/withTranslations';
//
import { openNotificationWithIcon } from 'app/components/Utility/notificationMessage';
//
import { Type } from 'app/constants/TourPoints';

const RideTwisterSetPoint = (props) => {
  const { tr, setStartPoint, isClearTour, startPoint, points } = props;
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((store) => store.authentication);
  const { homeAddress } = useSelector((store) => store.userReducer);
  const [position, setPosition] = useState(0);

  const addPointToDrive = (lat, lng, fromMap = false) => {
    setPosition(1);
    if (setStartPoint) setStartPoint({ lat, lng });
    const data = {
      lat,
      lng,
      type: 'start',
      draggable: true,
    };
    if (!fromMap) {
      data.iconType = `${Type.HOME}_start`;
    }
    if (fromMap) {
      publish(way.DRIVE_CLEAR_DATA, {});
    }
    publish(way.DRIVE_MAP_CLICK, data);
  };

  const takeAddressByClickMap = () => {
    publish(way.CLUB_EDIT_GET_ADDRESS_FROM_MAP_OFF);
    dispatch(setTypeMouseCursor(`cursor_${Type.START}`));
    publish(way.CLUB_EDIT_GET_ADDRESS_FROM_MAP_ON, (e) => {
      const { lat, lng } = e.latlng;
      addPointToDrive(lat, lng, true);
      setPosition(2);
      publish(way.CLUB_EDIT_GET_ADDRESS_FROM_MAP_OFF);
      dispatch(setTypeMouseCursor(''));
    });
  };

  useEffect(() => {
    if (points[0]) {
      setPosition(2);
    }
  }, []);

  useEffect(() => {
    if (isClearTour) {
      return;
    }
    const { lat, lng } = homeAddress;
    if (!isLoggedIn) {
      openNotificationWithIcon(
        'info',
        tr['Log in to use your home position or set it directly on the map']
      );
    } else if (!lat && !lng && !startPoint) {
      openNotificationWithIcon(
        'info',
        tr[
          'Set home position to use it as a start point or press the button to set the start point'
        ]
      );
    }
    if (lat && lng && !isClearTour && !points[0]) {
      addPointToDrive(lat, lng);
    }
  }, [isClearTour]);

  useEffect(() => {
    if (!points[0]) {
      const { lat, lng } = homeAddress;
      if (lat && lng) {
        addPointToDrive(lat, lng);
      }
    }
  }, [homeAddress]);

  const getPosition = (pos) => {
    switch (pos) {
      case 1:
        return tr.Home;
      case 2:
        return tr.Custom;
      default:
        return tr['Not set yet'];
    }
  };

  return (
    <div className="setPointLayout">
      <div className="startMode">
        {`${tr['Start point']} - `}
        <span>{getPosition(position)}</span>
      </div>
      <Button size="small" onClick={() => takeAddressByClickMap()}>
        <span>{tr['Set the start position on the map']}</span>
      </Button>
    </div>
  );
};

export default React.memo(withTranslations(RideTwisterSetPoint));
